import { useState } from 'react';
import { LUNGHEZZA_MINIMA_PASSWORD } from '@pmo/shared';
import { cambiaPassword, esci } from '../../lib/api.js';
import { CampoPassword, Guasto } from '../../components/pezzi.js';

/**
 * Serve a due momenti diversi, ed è la stessa schermata:
 *   · l'operatore la apre da sé per cambiare la propria password;
 *   · l'applicativo gliela mette davanti quando `mustChangePassword` è vero, e
 *     in quel caso non si va da nessun'altra parte finché non l'ha fatto.
 * 🚨 Cambiarla chiude tutte le ALTRE sessioni: sta scritto qui perché è un
 * effetto che si vede su un altro dispositivo, dove nessuno lo sta leggendo.
 */
export function CambioPassword({ obbligato }: { obbligato: boolean }): React.JSX.Element {
  const [attuale, setAttuale] = useState('');
  const [nuova, setNuova] = useState('');
  const [ripeti, setRipeti] = useState('');
  const [fatto, setFatto] = useState(false);
  const [inCorso, setInCorso] = useState(false);
  const [errore, setErrore] = useState<unknown>(null);

  const diverse = ripeti !== '' && ripeti !== nuova;

  async function manda(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setErrore(null);
    if (diverse) return;
    setInCorso(true);
    try {
      await cambiaPassword(attuale, nuova);
      setFatto(true);
      setAttuale('');
      setNuova('');
      setRipeti('');
    } catch (err) {
      setErrore(err);
    } finally {
      setInCorso(false);
    }
  }

  return (
    <section className="riquadro stretto">
      <h2>{obbligato ? 'Scegli una password nuova' : 'Cambia la password'}</h2>
      {obbligato && (
        <p className="tenue">
          Finché non l’hai fatto, il resto del gestionale resta chiuso — anche per il server, non solo a
          schermo.
        </p>
      )}
      <form onSubmit={manda}>
        <CampoPassword
          etichetta="Password attuale"
          autoComplete="current-password"
          required
          value={attuale}
          onChange={(e) => setAttuale(e.target.value)}
        />
        <CampoPassword
          etichetta="Password nuova"
          autoComplete="new-password"
          required
          minLength={LUNGHEZZA_MINIMA_PASSWORD}
          value={nuova}
          onChange={(e) => setNuova(e.target.value)}
        />
        <CampoPassword
          etichetta="Ripetila"
          autoComplete="new-password"
          required
          value={ripeti}
          onChange={(e) => setRipeti(e.target.value)}
        />
        {diverse && <p className="guasto">Le due password non coincidono.</p>}
        <Guasto errore={errore} />
        {/* Il «fatto» compare DOPO la risposta del server, mai prima (§ 03.7). */}
        {fatto && <p className="riuscito">Password cambiata. Le altre sessioni aperte sono state chiuse.</p>}
        <button type="submit" disabled={inCorso || diverse}>
          {inCorso ? 'Un attimo…' : 'Cambia la password'}
        </button>
      </form>
      {obbligato && (
        <button type="button" className="piatto" onClick={() => void esci()}>
          Esci
        </button>
      )}
    </section>
  );
}
